var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"breadcrumbs subtitle-2"},[_c('router-link',{attrs:{"to":{ name: 'home'}}},[_vm._v("Home")]),_vm._v(" > Tag\n  ")],1),_c('PostGrid',{attrs:{"title":_vm.expandTag(_vm.tag),"fetchUrl":_vm.tagUrl,"showCount":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }